module.exports = __webpack_public_path__ + "img/1531358268.bdc629ae.jpg";